import { applyMiddleware, combineReducers, createStore } from "redux";
import { composeWithDevTools } from "redux-devtools-extension";
import { createLogger } from "redux-logger";
import thunk from "redux-thunk";

// reducers
import { areaReducers } from "./reducers/areaReducers";
import { authReducer } from "./reducers/authReducers";
import { autoScaleReducers } from "./reducers/autoScaleReducers";
import { carBrandReducers } from "./reducers/carBrandReducers";
import { cardTypeReducers } from "./reducers/cardTypeReducers";
import { cargo2Reducers } from "./reducers/cargo2Reducers";
import { cargoMainReducers } from "./reducers/cargoMainReducers";
import { cargoReducer } from "./reducers/cargoReducer";
import { cargoTypeReducers } from "./reducers/cargoTypeReducers";
import { carModelReducers } from "./reducers/carModelReducers";
import { companyAllowedIpAddressReducers } from "./reducers/companyAllowedIpAddressReducers";
import { companyReducers } from "./reducers/companyReducers";
import { customerBranchReducers } from "./reducers/customerBranchReducers";
import { customerReducer } from "./reducers/customerReducer";
import { customerWarehouseReducers } from "./reducers/customerWarehouseReducers";
import { deliveryTypeReducers } from "./reducers/deliveryTypeReducers";
import { districtReducers } from "./reducers/districtReducers";
import { historyReducers } from "./reducers/historyReducers";
import { incomeOperationReducers } from "./reducers/incomeOperationReducers";
import { logonRequestsReducers } from "./reducers/logonRequestsReducers";
import { lpiReducers } from "./reducers/lpiReducers";
import { operationReducers } from "./reducers/operationReducers";
import { orderPartReducers } from "./reducers/orderPartReducers";
import { orderPartStepCompanyReducers } from "./reducers/orderPartStepCompanyReducers";
import { orderReducers } from "./reducers/orderReducers";
import { printTypesReducers } from "./reducers/printTypeReducers";
import { receiptReducers } from "./reducers/receiptReducers";
import { reportReducers } from "./reducers/reportReducers";
import { requestReducers } from "./reducers/requestReducers";
import { rfidCardOperationReducers } from "./reducers/rfidCardOperationReducers";
import { rfidCardReducers } from "./reducers/rfidCardReducers";
import { scaleCameraReducers } from "./reducers/scaleCameraReducers";
import { scalesReducers } from "./reducers/scalesReducers";
import { senderBranchReducers } from "./reducers/senderBranchReducers";
import { senderReducer } from "./reducers/senderReducers";
import { senderWarehouseReducers } from "./reducers/senderWarehouseReducers";
import { changeState } from "./reducers/sidebarReducer";
import { statusReducers } from "./reducers/statusReducers";
import { subOrderReducers } from "./reducers/subOrderReducers";
import { trailerCarBrandReducers } from "./reducers/trailerCarBrandReducers";
import { trailerReducers } from "./reducers/trailerReducers";
import { truckOwnerReducer } from "./reducers/truckOwnerReducers";
import { truckReducer } from "./reducers/truckReducer";
import { truckTypeReducers } from "./reducers/truckTypeReducers";
import { userGroupsReducer } from "./reducers/userGroupsReducers";
import { usersReducer } from "./reducers/usersReducers";

const logger = createLogger({
  level: "info",
  collapsed: true,
});

// middlewares;
const middlewares = [thunk];

if (process.env.NODE_ENV === "development") {
  middlewares.push(logger);
}

const reducers = combineReducers({
  changeState,
  customers: customerReducer,
  cargos: cargoReducer,
  cargo2: cargo2Reducers,
  auth: authReducer,
  users: usersReducer,
  user_groups: userGroupsReducer,
  status: statusReducers,
  companies: companyReducers,
  sender: senderReducer,
  trucks: truckReducer,
  truck_owner: truckOwnerReducer,
  operations: operationReducers,
  receipts: receiptReducers,
  scales: scalesReducers,
  printTypes: printTypesReducers,
  reports: reportReducers,
  requests: requestReducers,
  cardTypes: cardTypeReducers,
  rfidCards: rfidCardReducers,
  rfidCardOperations: rfidCardOperationReducers,
  orders: orderReducers,
  cargoMain: cargoMainReducers,
  area: areaReducers,
  district: districtReducers,
  customerBranch: customerBranchReducers,
  senderBranch: senderBranchReducers,
  carBrand: carBrandReducers,
  carModel: carModelReducers,
  history: historyReducers,
  incomeOperation: incomeOperationReducers,
  lpi: lpiReducers,
  truckType: truckTypeReducers,
  customerWarehouse: customerWarehouseReducers,
  senderWarehouse: senderWarehouseReducers,
  trailerCarBrand: trailerCarBrandReducers,
  trailer: trailerReducers,
  companyAllowedIpAddress: companyAllowedIpAddressReducers,
  scaleCamera: scaleCameraReducers,
  orderParts: orderPartReducers,
  logonRequests: logonRequestsReducers,
  subOrders: subOrderReducers,
  orderPartStepCompany: orderPartStepCompanyReducers,
  cargoType: cargoTypeReducers,
  deliveryType: deliveryTypeReducers,
  autoScale: autoScaleReducers,
});

const store = createStore(
  reducers,
  composeWithDevTools(applyMiddleware(...middlewares))
);
export default store;
